import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes";

// layouts
import NonAuthLayout from "./components/NonAuthLayout";
import VerticalLayout from "./components/VerticalLayout/";

// Import scss
import "./assets/scss/theme.scss";

import AppRoute from "./routes/route";
import { ThemeProvider } from "@mui/material";
import { createTheme } from '@mui/material/styles';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Import the i18n configuration


//Firebase helper
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// const firebaseConfig = {
// 	apiKey: process.env.REACT_APP_APIKEY,
// 	authDomain: process.env.REACT_APP_AUTHDOMAIN,
// 	databaseURL: process.env.REACT_APP_DATABASEURL,
// 	projectId: process.env.REACT_APP_PROJECTID,
// 	storageBucket: process.env.REACT_APP_STORAGEBUCKET,
// 	messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
// 	appId: process.env.REACT_APP_APPID,
// 	measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	/**
   * Returns the layout
   */

	render() {
		const Layout = VerticalLayout;
		const theme = createTheme({
			components: {
				MuiSwitch: {
					styleOverrides: {
						root: { width: 38, height: 24, padding: 0, margin: '0 6px', flexShrink: 0 },
						switchBase: {
							padding: 3, color: '#fff',
							'&.Mui-checked': { transform: 'translateX(14px)', color: '#fff', '& + .MuiSwitch-track': { backgroundColor: '#c8195c', opacity: 1 } },
							'&.Mui-disabled + .MuiSwitch-track': { opacity: 0.5 },
						},
						thumb: { width: 18, height: 18, boxShadow: '0 1px 3px rgba(20,36,47,.25)' },
						track: { borderRadius: 12, backgroundColor: '#dbe2e9', opacity: 1 },
					},
				},
			},
			typography: {
				fontFamily: 'Nunito',
				fontSize: 12.25,
			},
			formlabel: {
				fontFamily: 'Nunito',
			},
			formControlLabel: {
				fontFamily: 'Nunito',
			},

		});

		return (
			<React.Fragment>
				<ThemeProvider theme={theme}>
					<I18nextProvider i18n={i18n}>
						<Routes>
							{publicRoutes.map((route, idx) => (
								<Route
									path={route.path}
									element={
										<NonAuthLayout>
											{route.component}
										</NonAuthLayout>
									}
									key={idx}
									exact={true}
								/>
							))}

							{authProtectedRoutes.map((route, idx) => (
								<Route
									path={route.path}
									element={
										<AppRoute requiredPermission={route.requiredPermission}>
											<Layout>{route.component}</Layout>
										</AppRoute>
									}
									key={idx}
									exact={true}
								/>
							))}
						</Routes>
					</I18nextProvider>

				</ThemeProvider>

				{/* <Router>
					<Routes>
						{publicRoutes.map((route, idx) => (
							<AppRoute
								path={route.path}
								layout={NonAuthLayout}
								component={route.component}
								key={idx}
								isAuthProtected={false}
							/>
						))}

						{authProtectedRoutes.map((route, idx) => (
							<AppRoute
								path={route.path}
								layout={Layout}
								component={route.component}
								key={idx}
								isAuthProtected={true}
							/>
						))}
					</Routes>
				</Router> */}


			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		layout: state.Layout
	};
};


export default connect(mapStateToProps, null)(App);
